module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_02-c250af7ba88bbcf5fcb6ddefe1bb0344.png";